import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

function PrepTimeWarning({ prepTimeMinutes, prepTimeWarnings, booking }) {
  const [currentWarning, setCurrentWarning] = useState(null);

  useEffect(() => {
    const updateWarning = () => {
      if (!prepTimeWarnings || !prepTimeMinutes) return;

      const now = dayjs();
      const startTime = dayjs(booking.startTime);

      // Wenn der Kunde eingecheckt ist, verwende presentSince als Referenzzeitpunkt
      const referenceTime = booking.presentSince ? dayjs(booking.presentSince) : now;
      const minutesUntilStart = startTime.diff(referenceTime, 'minute');

      // Find the most severe warning that applies
      const applicableWarning = prepTimeWarnings
        .filter(warning => {
          if (minutesUntilStart < 0) {
            // Wenn die Zeit abgelaufen ist, zeige die Warnung mit dem kleinsten fromMinutes
            return warning.fromMinutes === Math.min(...prepTimeWarnings.map(w => w.fromMinutes));
          }
          // Ansonsten normale Logik
          return minutesUntilStart <= warning.fromMinutes;
        })
        .sort((a, b) => {
          const severityOrder = { danger: 3, warning: 2, info: 1 };
          return severityOrder[b.type] - severityOrder[a.type];
        })[0];

      setCurrentWarning(applicableWarning);
    };

    // Update immediately and then every 10 seconds
    updateWarning();
    const interval = setInterval(updateWarning, 10000);

    return () => clearInterval(interval);
  }, [prepTimeWarnings, prepTimeMinutes, booking.startTime, booking.presentSince]);

  if (!currentWarning) return null;

  const getWarningStyle = type => {
    const baseStyle = {
      padding: '12px',
      marginBottom: '16px',
      borderRadius: '4px',
      border: '2px solid',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1.1em',
    };

    switch (type) {
      case 'info':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(0, 0, 255, 0.1)',
          borderColor: 'blue',
          color: 'blue',
        };
      case 'warning':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(255, 165, 0, 0.1)',
          borderColor: 'orange',
          color: 'orange',
        };
      case 'danger':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(255, 0, 0, 0.1)',
          borderColor: 'red',
          color: 'red',
        };
      default:
        return baseStyle;
    }
  };

  return <Box sx={getWarningStyle(currentWarning.type)}>{currentWarning.message}</Box>;
}

export default PrepTimeWarning;
